import HeartIconButton from '@c/icons/buttons/HeartButton';
import ProductViewerModal from '@c/modals/ProductViewerModal';
import ProductCarousel from '@ui/ProductCarousel';
import { ProductDocument, Variation } from '@models/product';
import { useState, memo } from 'react';
import Image from 'next/image';

const ProductDetailsImages = ({
  product,
  selectedVariations,
}: {
  product: ProductDocument;
  selectedVariations: Variation[] | null;
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(
    product.video ? -1 : 0
  );

  if (!product?.images)
    return (
      <Image
        alt="No Images Found"
        width={500}
        height={500}
        src="/not_found.svg"
      />
    );

  return (
    <div className="relative grow sm:max-w-fit lg:mt-[1rem]">
      <ProductCarousel
        product={product}
        openProductViewer={(index: number) => {
          setCurrentImageIndex(index);
          setOpenModal(true);
        }}
        selectedVariations={selectedVariations}
        stack
      />

      {openModal && (
        <ProductViewerModal
          key={currentImageIndex}
          isOpen={openModal}
          dismiss={() => setOpenModal(false)}
          images={product.images}
          video={product.video}
          initialImage={currentImageIndex}
        />
      )}
    </div>
  );
};

// Memoize this component to prevent unnecessary re-renders and image flickers
export default memo(ProductDetailsImages);
